import { render, staticRenderFns } from "./aiTrustFromWindow.vue?vue&type=template&id=2ab00f13&"
import script from "./aiTrustFromWindow.vue?vue&type=script&lang=js&"
export * from "./aiTrustFromWindow.vue?vue&type=script&lang=js&"
import style0 from "./aiTrustFromWindow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ab00f13')) {
      api.createRecord('2ab00f13', component.options)
    } else {
      api.reload('2ab00f13', component.options)
    }
    module.hot.accept("./aiTrustFromWindow.vue?vue&type=template&id=2ab00f13&", function () {
      api.rerender('2ab00f13', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/AirImport/components/booking/aiTrustFromWindow.vue"
export default component.exports